"use client";

import { useQuery } from "@tanstack/react-query";

import { createPromotionService } from "@/shared/api/services/promotionService";
import { useBuyerService } from "@/shared/auth/hooks";

export const promotionKeys = {
  all: ["promotions"] as const,
  chuseok: () => ["promotions", "chuseok"] as const,
  familyMonth: () => ["promotions", "family-month"] as const,
  autumnNewArrivals: () => ["promotions", "autumn-new-arrivals"] as const,
  springCollection: () => ["promotions", "spring-collection"] as const,
  mdsPick: () => ["promotions", "mds-pick"] as const,
};

export function useChuseok() {
  const service = useBuyerService(createPromotionService);
  return useQuery({
    queryKey: promotionKeys.chuseok(),
    queryFn: () => service.getChuseok(),
  });
}

export function useFamilyMonth() {
  const service = useBuyerService(createPromotionService);
  return useQuery({
    queryKey: promotionKeys.familyMonth(),
    queryFn: () => service.getFamilyMonth(),
  });
}

export function useSpringCollection() {
  const service = useBuyerService(createPromotionService);
  return useQuery({
    queryKey: promotionKeys.springCollection(),
    queryFn: () => service.getSpringCollection(),
  });
}

export function useAutumnNewArrivals() {
  const service = useBuyerService(createPromotionService);
  return useQuery({
    queryKey: promotionKeys.autumnNewArrivals(),
    queryFn: () => service.getAutumnNewArrivals(),
  });
}

export function useMdsPick() {
  const service = useBuyerService(createPromotionService);
  return useQuery({
    queryKey: promotionKeys.mdsPick(),
    queryFn: () => service.getMdsPick(),
  });
}
